import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { useState } from "react";

export function ProfessionalPicker({
  professionals,
  selectedProfessionalId,
  onSelect,
  disabled = false,
}: {
  professionals: { id: string; name: string }[];
  selectedProfessionalId?: string | null;
  onSelect: (id: string | null) => void;
  disabled?: boolean;
}) {
  const [search, setSearch] = useState("");

  const filtered = professionals.filter((p) =>
    p.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Select
      value={selectedProfessionalId ?? ""}
      onValueChange={(value) => onSelect(value || null)}
      disabled={disabled}
    >
      <SelectTrigger className="w-[300px]">
        <SelectValue placeholder="Select professional..." />
      </SelectTrigger>

      <SelectContent className="bg-white max-h-[200px] shadow-md rounded-md overflow-y-auto">
        {/* Search box inside dropdown */}
        <div className="p-2 sticky top-0 bg-white border-b z-10">
            <Input
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => e.stopPropagation()} // 👈 stops Radix from eating keystrokes
            className="h-8"
            />
        </div>

        <div className="max-h-[160px] overflow-y-auto">
            {filtered.length > 0 ? (
            filtered.map((professional) => (
                <SelectItem key={professional.id} value={professional.id}>
                {professional.name}
                </SelectItem>
            ))
            ) : (
            <div className="p-2 text-sm text-muted-foreground">
                No professionals found
            </div>
            )}
        </div>
        </SelectContent>

    </Select>
  );
}
